import React, { FC } from "react";
import { Text, View,Linking,TouchableOpacity } from "react-native";
import { Style, StyleArray, styles } from "../../theme/styles";
import { useTheme } from "../../theme/colors";
import { Button, Gap } from "../../components";
import { ButtonType, IsMobile } from "../../theme";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { AuthStackParams } from "../../navigation/Auth/AuthStackParams";
import { LoginRoute } from "../../navigation/Auth/routes";
import useAuth from "../../contexts/Auth/useAuth";
import OneSpaceLogo from "../../Icons/OneSpaceLogo";

const OrganizationAccessDenied: FC = () => {
  const navigation = useNavigation<NavigationProp<AuthStackParams>>();
  const theme = useTheme();
  const { accessLink,accessErrorMessage} = useAuth();
  return (
    <View
      style={[
        ...$container,
        { backgroundColor: theme.BACKGROUND, padding: 20 },
      ]}
    >
      <OneSpaceLogo width={300} height={200} />
      <View style={$body}>
        <View style={[IsMobile ? {} : { width: 300 }]}>
        <Text style={{ ...$teaser, color: theme.TEXT }}>
          {accessErrorMessage}
        </Text>
        <TouchableOpacity onPress={()=>{ if(accessLink)Linking.openURL(accessLink)}}>
        <Text style={{ ...$teaser,color: "blue", textDecorationLine: "underline", marginTop: 20 }}>
          {accessLink}
        </Text>
      </TouchableOpacity>

        </View>
      </View>
      <Gap gap={80} />
      <View style={{ gap: 20 }}>
        <Button
          variant={ButtonType.secondary}
          title="Login"
          onPress={() => navigation.navigate(LoginRoute)}
        />
      </View>
    </View>
  );
};

export default OrganizationAccessDenied;

const $container: StyleArray = [styles.flex1, styles.center];
const $teaser: Style = {
  ...styles.textCenter,
  fontWeight: "600",
};

const $body: Style = {
  ...styles.center,
  marginTop: 40,
};
